import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
const ListTaiSanForm = (props) => {
  let {
    comboLoaiTaiSan,
    getThuocTinhTaiSan1,
    onChange,
    thuoctinhtaisan,
    objComboStore,
    listTaiSan,
    cauHinhPhiKho,
  } = props;
  let [listTaiSanCurent, setListTaiSanCurent] = useState(listTaiSan);
  let { objThuocTinhTaiSan1 } = thuoctinhtaisan;
  const [loaiTaiSan, setLoaiTaiSan] = useState("");
  const [loadedLsTaiSan, setloadedLsTaiSan] = useState(false);
  const [tenTaiSan, setTenTaiSan] = useState("");
  const [storeID, setStoreID] = useState("");
  const [code, setCode] = useState("");
  const [phiKho, setPhiKho] = useState(0);
  const [note, setNote] = useState("");
  const [indexEdit, setIndexEdit] = useState(-1);
  const [TaiSan1ID, setTaiSan1ID] = useState(0);
  const [ThuocTinhTaiSan, setThuocTinhTaiSan] = useState(objThuocTinhTaiSan1);
  useEffect(() => {
    if (!thuoctinhtaisan.thuocTinhTaiSan1Loaded && comboLoaiTaiSan.length > 0) {
      getThuocTinhTaiSan1({ loaiTaiSan: comboLoaiTaiSan[0].value });
      setLoaiTaiSan(comboLoaiTaiSan[0].value);
    }
    if (!loadedLsTaiSan && listTaiSan && listTaiSan.length > 0) {
      setListTaiSanCurent(listTaiSan);
    }
    if (objComboStore && objComboStore.length > 0 && storeID === "") {
      setStoreID(objComboStore[0].value);
    }
  });

  if (objThuocTinhTaiSan1.length !== ThuocTinhTaiSan.length) {
    let listThuocTinhTS = [];
    for (let index = 0; index < objThuocTinhTaiSan1.length; index++) {
      const element = objThuocTinhTaiSan1[index];
      listThuocTinhTS.push({
        TenThuocTinh: element.TenThuocTinh,
        OptionValue: "",
        OptionName: element.MaThuocTinh,
      });
    }
    setThuocTinhTaiSan(listThuocTinhTS);
  }
  //storeID
  const onChangeLoaiTaiSan1 = (evt) => {
    setLoaiTaiSan(evt.target.value);
    getThuocTinhTaiSan1({ loaiTaiSan: evt.target.value });
  };

  const setThuocTinhTaiSan1 = (index) => (evt) => {
    ThuocTinhTaiSan[index].OptionValue = evt.target.value;
    setThuocTinhTaiSan(ThuocTinhTaiSan);
    setTaiSan1ID(TaiSan1ID ? 0 : 1);
  };
  const setTenTaiSan1 = () => (evt) => {
    if (evt.target.value.length === 0) {
      error.tenTaiSan = { message: "Hãy nhập tên tài sản" };
      setError(error);
      TenTaiSan.current.focus();
    } else {
      error.tenTaiSan = null;
      setError(error);
    }
    setTenTaiSan(evt.target.value);
  };
  const [error, setError] = useState({});
  const [imageTaiSans, setImageTaiSans] = useState([]);

  const TenTaiSan = React.createRef();
  const submitData = () => {
    if (tenTaiSan.length === 0) {
      error.tenTaiSan = { message: "Hãy nhập tên tài sản" };
      setError(error);
      TenTaiSan.current.focus();
    } else {
      error.tenTaiSan = null;
      setError(error);
    }
    if (indexEdit > -1)
      listTaiSanCurent[indexEdit] = {
        CategoryId: listTaiSanCurent[indexEdit].CategoryId,
        Code: code,
        TenTaiSan: tenTaiSan,
        Note: note,
        Status: 1,
        Type: 1,
        StoreID: storeID,
        PhiKho: phiKho,
        LoaiTaiSan: loaiTaiSan,
        ThuocTinhTaiSan: ThuocTinhTaiSan,
        AnhTaiSan: imageTaiSans.join(","),
      };
    else
      listTaiSanCurent.push({
        CategoryId: 0,
        Code: code,
        TenTaiSan: tenTaiSan,
        Note: note,
        Status: 1,
        Type: 1,
        StoreID: storeID,
        PhiKho: phiKho,
        LoaiTaiSan: loaiTaiSan,
        ThuocTinhTaiSan: ThuocTinhTaiSan,
        AnhTaiSan: imageTaiSans.join(","),
      });
    onChange(listTaiSanCurent);
    setListTaiSanCurent(listTaiSanCurent);
    for (let index = 0; index < ThuocTinhTaiSan.length; index++) {
      ThuocTinhTaiSan[index].OptionValue = "";
    }
    setThuocTinhTaiSan(ThuocTinhTaiSan);
    setTenTaiSan("");
    setTenTaiSan("");
    setIndexEdit(-1);
    setCode("");
    setNote("");
    setPhiKho("");
  };
  const xoaTaiSan = (index) => () => {
    listTaiSanCurent.splice(index, 1);
    onChange(listTaiSanCurent);
    setListTaiSanCurent(listTaiSanCurent);
    setTenTaiSan("");
  };
  const editTaiSan = (item, index) => () => {
    setTenTaiSan(item.TenTaiSan);
    setLoaiTaiSan(item.LoaiTaiSan);
    setCode(item.Code);
    setNote(item.Note);
    setPhiKho(item.PhiKho);
    setStoreID(item.StoreID);
    setImageTaiSans(item.AnhTaiSan.split(","));
    setIndexEdit(index);
  };
  return (
    <div className="card-content">
      <div className="from-full-taisan">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <input
                  type="text"
                  name="TaiSan1ID"
                  value={TaiSan1ID}
                  className="hidden"
                ></input>
                <div className="form-group">
                  <label>Loại tài sản</label>
                  <select
                    name="ListHangTheChap[1].LoaiTaiSan"
                    className="selectBox form-control input-sm"
                    onChange={onChangeLoaiTaiSan1}
                    value={loaiTaiSan}
                  >
                    {comboLoaiTaiSan &&
                      comboLoaiTaiSan.map((item, idx) => (
                        <option
                          key={"comboLoaiTaiSan1" + idx}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <TextInputOnRow
                  labelClass="label-control"
                  inputClass="form-control input-sm"
                  wrapperClass="form-group"
                  labelText="Tên tài sản"
                  placeholder="Lead 2018"
                  inputProps={{
                    value: tenTaiSan,
                    onChange: setTenTaiSan1(),
                    ref: TenTaiSan,
                  }}
                  error={error && error.tenTaiSan}
                ></TextInputOnRow>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label className="label-control">Kho</label>
                  <select
                    name="ListHangTheChap[0].StoreID"
                    className="selectBox form-control input-sm"
                    value={storeID}
                    onChange={(evt) => setStoreID(evt.target.value)}
                  >
                    {objComboStore &&
                      objComboStore.map((item, idx) => (
                        <option key={"objComboStore1" + idx} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <TextInputOnRow
                  labelClass="label-control"
                  inputClass="form-control input-sm"
                  wrapperClass="form-group"
                  labelText="Mã tài sản"
                  inputProps={{
                    value: code,
                    onChange: (evt) => setCode(evt.target.value),
                  }}
                ></TextInputOnRow>
              </div>
              {cauHinhPhiKho === 1 && (
                <div className="col-md-3">
                  <div className="form-group">
                    <label className="label-control">Phí kho/ngày</label>
                    <NumberFormat
                      thousandSeparator={true}
                      prefix={""}
                      inputmode="numeric"
                      className="form-control input-sm"
                      placeholder="5"
                      onChange={(evt) => setPhiKho(evt.target.value)}
                      value={phiKho}
                    />
                  </div>
                </div>
              )}

              <div className="col-md-9">
                <div className="form-group">
                  <label>Ghi chú</label>
                  <textarea
                    rows="1"
                    className="form-control input-sm text-era"
                    name="ListHangTheChap[1].Note"
                    placeholder="Ghi chú"
                    value={note}
                    onChange={(evt) => setNote(evt.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mt-1">
            <div className="row">
              <div className="col-md-12">
                <h4 className="form-section">
                  <i className="la la-file-text"></i>
                  Thuộc tính tài sản
                </h4>
              </div>
              {ThuocTinhTaiSan &&
                ThuocTinhTaiSan.map((item, index) => (
                  <div className="col-md-3" key={"Thuoctinhts11" + index}>
                    <TextInputOnRow
                      labelClass="label-control"
                      inputClass="form-control input-sm"
                      wrapperClass="form-group"
                      labelText={item.TenThuocTinh}
                      inputProps={{
                        name: "ThuocTinhTaiSan[" + index + "].OptionValue",
                        value: ThuocTinhTaiSan[index].OptionValue,
                        onChange: setThuocTinhTaiSan1(index),
                      }}
                    ></TextInputOnRow>
                    <input
                      type="hidden"
                      name={
                        "ListHangTheChap[1].ThuocTinhTaiSan[" +
                        index +
                        "].OptionName"
                      }
                      value={item.MaThuocTinh}
                    ></input>
                  </div>
                ))}
            </div>
          </div>
          <div className="col-md-12 mt-1">
            <div className="row">
              <div className="col-md-12">
                <UploadMultiFile
                  images={imageTaiSans}
                  onChange={setImageTaiSans}
                ></UploadMultiFile>
              </div>
            </div>
          </div>
        </div>

        <div className="form-actions right">
          <button type="button" className="btn btn-info" onClick={submitData}>
            <i className="fas fa-save"></i> Lưu tài sản
          </button>
        </div>
        <div class="table-responsive table-2">
          <table
            class="table table-bordered mb-0"
            cellSpacing="0"
            rules="all"
            border="0"
            style={{ borderWidth: "0px", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <th scope="col" style={{ width: "2%" }}>
                  <span class="color5">STT</span>
                </th>
                <th scope="col">
                  <span class="color5">Mã tài sản</span>
                </th>
                <th scope="col">
                  <span class="color5">Tên tài sản</span>
                </th>
                <th scope="col">
                  <span class="color5">Ghi chú</span>
                </th>
                <th scope="col">
                  <span class="color5">Phí kho</span>
                </th>
                <th scope="col">
                  <span class="color6">Thao tác</span>
                </th>
              </tr>
              {listTaiSanCurent &&
                listTaiSanCurent.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.Code}</td>
                    <td>{item.TenTaiSan}</td>
                    <td>{item.Note}</td>
                    <td>{item.PhiKho}</td>
                    <td>
                      <a href="#" onClick={editTaiSan(item, index)}>
                        Sửa
                      </a>
                      |
                      <a href="#" onClick={xoaTaiSan(index)}>
                        Xóa
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ListTaiSanForm;
